import { AppDataHttp } from '../http.ts'

const headers = {
  'Content-type': 'application/json'
}

export const getUserSession = (accessToken: string) => {
  return AppDataHttp.get('/app-data/user-session', {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getHomeData = (systemUserId: string, selectedCountry: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/home-data/${systemUserId}/${selectedCountry}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getBatchesBriefData = (selectedCountry: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/batches-brief-data/${selectedCountry}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getBatchPaymentDetailsData = (documentId: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/batch-payment-details-data/${documentId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentsBriefData = (country: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/payments-brief-data/${country}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCustomerCompanyPaymentsData = (country: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/customer-company-payments-data/${country}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getBatchesCompletedData = (country: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/batches-completed-data/${country}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getBatchesReadyData = (country: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/batches-ready-data/${country}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getBatchesToReviewData = (country: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/batches-to-review-data/${country}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCustomerCompanyDetailsData = (customerCompanyId: string, selectedCountry: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/customer-company-details/${customerCompanyId}/${selectedCountry}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCustomerCompanyMoneyMovementsBySearch = (payload: object, accessToken: string) => {
  return AppDataHttp.post('/app-data/customer-company-money-movements-by-search', payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentsWithAlertsBySearch = (payload: object, accessToken: string) => {
  return AppDataHttp.post('/app-data/payments-with-alerts-by-search', payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentsPendingRoutingData = (customerCompanyId: string, country: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/payments-pending-routing/${customerCompanyId}/${country}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentsWithAlertsData = (customerCompanyId: string, country: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/payments-with-alerts/${customerCompanyId}/${country}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPocketsTransfersByCountry = (selectedCountry: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/pockets-transfers/${selectedCountry}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPocketsTransfersByCustomerCompany = (customerCompanyId: string, selectedCountry: string, pocketTransferId: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/pockets-transfers/${customerCompanyId}/${pocketTransferId}/${selectedCountry}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentPendingRoutingDetailsData = (paymentId: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/payment-pending-routing-details/${paymentId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentWithAlertsDetailsData = (paymentId: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/payment-with-alerts-details/${paymentId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentReviewedDetailsData = (paymentId: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/payment-reviewed-details/${paymentId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getBatchDetailsDataById = (documentId: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/batch-details-by-id/${documentId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentsWithSamePaymentReference = (paymentId: string, paymentReference: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/payments-with-same-reference/${paymentId}/${paymentReference}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentsToReviewData = (payload: object, accessToken: string) => {
  return AppDataHttp.post('/app-data/payments-to-review', payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentsCompletedData = (payload: object, accessToken: string) => {
  return AppDataHttp.post('/app-data/payments-completed', payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentsRejectedData = (payload: object, accessToken: string) => {
  return AppDataHttp.post('/app-data/payments-rejected', payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCustomerDetailsData = (customerId: string, accessToken: string) => {
  return AppDataHttp.get(`/app-data/customer-details-data/${customerId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}
